import ScrollAnimation from "react-animate-on-scroll";
import angularIcon from "../../assets/angular.webp";
import argoCDIcon from "../../assets/argocd.webp";
import awsIcon from "../../assets/aws.svg";
import hibernateIcon from "../../assets/hibernate.png";
import javaIcon from "../../assets/java.png";
import jenkinsIcon from "../../assets/jenkins.png";
import kafkaIcon from "../../assets/kafka.png";
import kubernetesIcon from "../../assets/kubernetes.png";
import mysqlIcon from "../../assets/mysql.png";
import nodeIcon from "../../assets/node-icon.svg";
import pythonIcon from "../../assets/python.png";
import graphqlIcon from "../../assets/rabbitmq.png";
import reactIcon from "../../assets/react-icon.svg";
import springIcon from "../../assets/spring.png";
import terraformIcon from "../../assets/terraform.png";

import Shanmu from "./../../assets/shan1.png";

import { Container } from "./styles";

const skills = [
  { name: "Java 21/17", icon: javaIcon },
  { name: "Spring Boot 3", icon: springIcon },
  { name: "React 19", icon: reactIcon },
  { name: "Node.js", icon: nodeIcon },
  { name: "Hibernate", icon: hibernateIcon },

  { name: "Kubernetes", icon: kubernetesIcon },
  { name: "GraphQL", icon: graphqlIcon },
  { name: "AWS", icon: awsIcon },
  { name: "Angular 18", icon: angularIcon },
  // { name: "Docker", icon: dockerIcon },
  // { name: "Redis Stack", icon: redisIcon },
  { name: "Apache Kafka", icon: kafkaIcon },
  { name: "MySQL", icon: mysqlIcon },
  { name: "Python", icon: pythonIcon },
  { name: "Terraform", icon: terraformIcon },
  { name: "CI/CD", icon: jenkinsIcon },
  { name: "Argo CD", icon: argoCDIcon }

];

export function ProfileSummary() {
  return (
    <Container id="profile-summary">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>Profile Summary</h2>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
            Highly experienced Software Engineer with over <b>16+ years</b> in designing and developing 
            scalable, cloud-native applications.
           </p>
        </ScrollAnimation>
        <br></br>
        <ScrollAnimation animateIn="fadeInLeft" delay={100}>
  <section className="mb-6">
    <h2 className="text-2xl font-semibold mb-2">Core Backend Development</h2>
    <ul className="list-none pl-0 space-y-2">
      <li>⭐ <strong>Expertise in Java 21/17/11</strong> and backend frameworks: Spring Boot 3, Quarkus, and Micronaut.</li>
      <li>⭐ <strong>Strong experience with Microservices Architecture,</strong> including Spring Cloud, Kubernetes, and API Gateway (Spring Gateway, Kong).</li>
      <li>⭐ <strong>Proficient in Reactive Programming</strong> using Spring WebFlux, Project Reactor.</li>
      <li>⭐ <strong>Hands-on experience with Virtual Threads</strong> (Project Loom) for highly scalable applications.</li>
      <li>⭐ <strong>Developed high-performance applications</strong> using GraalVM Native Image and Java Flight Recorder (JFR).</li>
    </ul>
  </section>
</ScrollAnimation>
<br></br>
<ScrollAnimation animateIn="fadeInLeft" delay={200}>
  <section className="mb-6">
    <h2 className="text-2xl font-semibold mb-2">Frontend UI Development</h2>
    <ul className="list-none pl-0 space-y-2">
      <li>⭐ <strong>Expertise in modern frontend frameworks:</strong> React 19, Next.js (RSC), Angular 18, Solid.js.</li>
      <li>⭐ <strong>Experience in HTMX</strong> and server-side rendering for lightweight frontends.</li>
      <li>⭐ <strong>Strong understanding of</strong> TypeScript, JavaScript (ES2024+), Tailwind CSS, and WebAssembly (Wasm).</li>
      <li>⭐ <strong>Built responsive web applications</strong> using Bootstrap, Material UI, and Chakra UI.</li>
    </ul>
  </section>
</ScrollAnimation>
<br></br>
<ScrollAnimation animateIn="fadeInLeft" delay={300}>
  <section className="mb-6">
    <h2 className="text-2xl font-semibold mb-2">Cloud & DevOps</h2>
    <ul className="list-none pl-0 space-y-2">
      <li>⭐ Hands-on experience with Kubernetes, OpenShift, and Serverless Architectures (AWS Lambda, Azure Functions).</li>
      <li>⭐ Implemented GitOps workflows using ArgoCD, FluxCD, and Kustomize.</li>
      <li>⭐ Strong expertise in CI/CD automation using Jenkins, GitHub Actions, and GitLab CI/CD.</li>
      <li>⭐ Experience with <strong>Infrastructure as Code (IaC)</strong> using Terraform, Pulumi, and Helm.</li>
    </ul>
  </section>
</ScrollAnimation>
<br></br>
<ScrollAnimation animateIn="fadeInLeft" delay={400}>
  <section className="mb-6">
    <h2 className="text-2xl font-semibold mb-2">Database & Storage Technologies</h2>
    <ul className="list-none pl-0 space-y-2">
      <li>⭐ Expertise in relational and NoSQL databases: PostgreSQL, MySQL 8, Oracle 21c, Azure Cosmos DB, and MongoDB.</li>
      <li>⭐ Experience with distributed and NewSQL databases: CockroachDB, TiDB, and YugabyteDB.</li>
      <li>⭐ Proficient in caching and in-memory databases: Redis Stack (JSON, Search, Graph).</li>
      <li>⭐ ORM experience with Hibernate 6, Spring Data JPA, and jOOQ.</li>
    </ul>
  </section>
</ScrollAnimation>
<br></br>
<ScrollAnimation animateIn="fadeInLeft" delay={500}>
  <section className="mb-6">
    <h2 className="text-2xl font-semibold mb-2">API & Messaging Systems</h2>
    <ul className="list-none pl-0 space-y-2">
      <li>⭐ Built GraphQL APIs using Spring GraphQL, Apollo Server.</li>
      <li>⭐ Developed RESTful APIs with Spring Boot, Flask, and FastAPI.</li>
      <li>⭐ Experience with event-driven architectures using Kafka, RabbitMQ, Pulsar, and NATS Streaming.</li>
    </ul>
  </section>
</ScrollAnimation>
<br></br>
<ScrollAnimation animateIn="fadeInLeft" delay={600}>
  <section className="mb-6">
    <h2 className="text-2xl font-semibold mb-2">Security & Performance Optimization</h2>
    <ul className="list-none pl-0 space-y-2">
      <li>⭐ Experience in Zero Trust Security Models, API security using OAuth 2.1, OIDC, JWT, and WebAuthn.</li>
      <li>⭐ Proficient in securing microservices using Spring Security 6, Keycloak, Open Policy Agent (OPA).</li>
      <li>⭐ Performance tuning using Java Flight Recorder (JFR), Micrometer, and GraalVM.</li>
    </ul>
  </section>
</ScrollAnimation>
<br></br>
<ScrollAnimation animateIn="fadeInLeft" delay={700}>
  <section className="mb-6">
    <h2 className="text-2xl font-semibold mb-2">Additional Technologies</h2>
    <ul className="list-none pl-0 space-y-2">
      <li>⭐ IBM Certified Blockchain Developer (Hyperledger Fabric, Ethereum Smart Contracts).</li>
      <li>⭐ Experience in Python (FastAPI, Pandas, PyTorch) and Rust for high-performance applications.</li>
      <li>⭐ Developed utilities and services using .NET 8 with C# 12.</li>
      <li>⭐ Experience in Edge Computing using WebAssembly (Wasm), Cloudflare Workers, Deno.</li>
      <li>⭐ Knowledge of Test-Driven Development (TDD) with JUnit 5, Testcontainers, and Playwright.</li>
    </ul>
  </section>
</ScrollAnimation>
<br></br>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
          <h2>Key Skills & Technologies</h2>
        </ScrollAnimation>

        <div className="hard-skills">
          {skills.map((skill, index) => (
            <div className="hability" key={skill.name}>
              <ScrollAnimation animateIn="fadeInUp" delay={0.1 * (index + 1) * 1000}>
                <img src={skill.icon} title={skill.name} />
                {/* <p>{skill.name}</p> */}
              </ScrollAnimation>
            </div>
          ))}
        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.21 * 1000}>
          <img src={Shanmu} alt="Shanmuga ganesh" />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
